import { Component } from '@angular/core';

@Component({
  selector: 'app-your-advantages-section',
  standalone: true,
  imports: [],
  templateUrl: './your-advantages-section.component.html',
  styleUrl: './your-advantages-section.component.scss'
})
export class YourAdvantagesSectionComponent {

}
